import { Currency } from '../Account';
import PreloadFlow from '../PreloadFlow';
import ValueSelector from '../Toolkit/Helper/ValueSelector';
import globalInstance from './GlobalInstance';

export default abstract class GlobalExport {
    public get isShowingError(): Readonly<boolean> {
        return globalInstance.game.message.hasFatalShown;
    }

    public get isLoading(): Readonly<boolean> {
        return PreloadFlow.isLoading;
    }

    public get currency(): Readonly<Currency | string> {
        return globalInstance.game.account.currency;
    }

    abstract get isIdleState(): Readonly<boolean>;

    abstract get betSelector(): ValueSelector<number>;
    abstract get currentPlayRuleType(): number;
    abstract set currentPlayRuleType(value: number);
    abstract get promoID(): string;
    abstract set promoID(value: string);

    abstract reconnect(): Promise<void>;
    abstract changePromoBet(): void; // 切換到 promo 道具的下注
    abstract resetBet(): void; // 還原原本的下注
    abstract lockPlayUI(): void; // 將遊玩相關的UI鎖住 (例如 SpinButton / AutoButton 等)
    abstract unlockPlayUI(): void; // 將遊玩相關的UI解鎖
    abstract spin(): Promise<boolean>; // 觸發下注 (回傳是否成功)
    abstract forceStopAutoMode(): void; // 強制停止自動模式
    abstract forceCloseAllPopups(): void; // 強制關閉所有彈窗
}
